// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3B09r","options":"style_options__2eARO","title":"style_title__bkqP0","content":"style_content__1puZF","list":"style_list__3TBoi"};